import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../context/UserContext';

interface ProtectedRouteProps {
  /** Required role. If omitted, any authenticated user is allowed. */
  role?: string;
}

export default function ProtectedRoute({ role }: ProtectedRouteProps) {
  const { user, loadingUser } = useUser();

  if (loadingUser) return null;

  if (!user) return <Navigate to="/login" replace />;

  if (role && user.role !== role) return <Navigate to="/dashboard" replace />;

  return <Outlet />;
}
